import { render, staticRenderFns } from "./ForgotSecurityAnswer.vue?vue&type=template&id=70bf32ec"
import script from "./ForgotSecurityAnswer.vue?vue&type=script&lang=js"
export * from "./ForgotSecurityAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports